/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import SliderList from '../../components/SliderList';
import Sidebar from '../../components/Sidebar';
import DataLoader from '../../components/DataLoader';
import ScrollableContent from '../../components/ScrollableContent';
import CoverCard from '../../components/CoverCard';
import actions from '../../redux/actions';
import { getFindFeaturedParams, getFeatured } from '../../redux/reducers/featured';
import protonesUtils from '../../utils/protones';

import styles from './styles.module.scss';

import type {
  ReactRouterProps,
  ReduxState,
  Fetchable,
  FindFeaturedParams,
  Featured,
  Translate,
} from '../../types';

type Props = ReactRouterProps & {
  params: FindFeaturedParams,
  featured: Fetchable<Featured[]>,
  pageScroll: number,
  fetchFeaturedList: typeof actions.fetchFeaturedList,
  featuredSetPageScroll: typeof actions.featuredSetPageScroll,
  t: Translate,
};

const mapStateToProps = (state: ReduxState, ownProps: Props) => {
  return {
    params: getFindFeaturedParams(state),
    featured: getFeatured(state),
    pageScroll: state.featured.pageScroll,
  };
};

class FeaturedClass extends React.Component<Props, void> {
  scrollContainer: any = React.createRef();
  pageScroll: number = 0;

  componentDidMount() {
    if (!this.props.featured.data) {
      this.props.fetchFeaturedList({});
    }
    if (this.scrollContainer.current) {
      this.scrollContainer.current.scrollTo(0, this.props.pageScroll);
    }
  }

  componentWillUnmount() {
    this.props.featuredSetPageScroll(this.pageScroll);
  }

  _handlePageScroll = (event: any) => {
    const element = event.target;
    const pageScroll = element.scrollTop;
    this.pageScroll = pageScroll;
  };

  _handleRefreshFeatured = () => {
    this.props.fetchFeaturedList({});
  };

  _handleFeaturedClick = (featured: Featured) => {
    protonesUtils.goTo(this.props, protonesUtils.routes.featured.get(featured.id));
  };

  _renderNoData = () => {
    return <div />;
  };

  _renderFeatured = data => {
    if (!data || !data.length) {
      return this._renderNoData();
    }
    return (
      <SliderList
        autoplay={true}
        items={data}
        render={item => (
          <CoverCard
            key={item.id}
            title={item.name}
            imgSrc={item.coverUrl}
            onClick={() => this._handleFeaturedClick(item)}
          />
        )}
        renderNoData={this._renderNoData}
        isExpanded={true}
      />
    );
  };

  render() {
    const {
      featured: { data, fetching, error },
      t,
    } = this.props;
    return (
      <div className={styles.root}>
        <Sidebar title={t('FEATURED')} onRefresh={this._handleRefreshFeatured} loading={fetching} />
        <ScrollableContent ref={this.scrollContainer} onScroll={this._handlePageScroll}>
          <div className={styles.main}>
            <DataLoader
              loading={fetching}
              error={error}
              data={data}
              render={this._renderFeatured}
            />
          </div>
        </ScrollableContent>
      </div>
    );
  }
}

export default withTranslation()(connect(mapStateToProps, actions)(FeaturedClass));
